var Handlebars = require("../../../tippspiel.thomasjacob.de/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"overlay-shim js_overlay-shim\" style=\"opacity:0\"></div>\n";
},"useData":true});